/* eslint-disable no-unused-vars */
export enum Buttons {
  SOLID = 'solid',
  OUTLINE = 'outline',
  BORDERLESS = 'borderless',
}
